/* eslint-disable prefer-destructuring */

import { createSlice } from "@reduxjs/toolkit";

interface PerformancePulseState {
  activeSegment: string;
  miniCardDetails: any[];
  topicDetails: any[];
  topicIds: Record<string, any>;
  metricDetails: any[];
  filterDetails: any[];
  filteredMetrics: any[];
  mainKPICardDetails: any[];
  selectedFilters: Record<string, any>;
  chartDetails: any[];
  filteredChartDetails: any[],
  renderingChartDetails: any[],
  isDogFoodActive: boolean,
  insights: any[],
  filteredInsights: any[],
  renderingInsights: any[],
  latestDate: string;
  // chartDetailsPerSegment
}

const initialState: PerformancePulseState = {
  activeSegment: "Sales Performance", // to know about the selected segment
  miniCardDetails: [], // Mini Card Details which are displayed based on the selected segment
  topicDetails: [], // Details of all topics
  topicIds: {}, // A json related to topic name and their ids
  metricDetails: [], // All metric details of all segments
  filterDetails: [], // filters for all segments
  filteredMetrics: [],// filtered metrics based on the selected filters for every segment. Whenever this is updated then we will call dispatch function of miniCardDetails to update the miniCardDetails which in turn updates the segment cards.
  mainKPICardDetails: [], // Main KPI Card Details which are displayed based on the InsightsHub page
  selectedFilters: {}, // Selected filters by user for every segment
  chartDetails: [], // All chart that are to be displayed in performance pulse
  filteredChartDetails: [], // filters applied on chartDetails for all segments
  renderingChartDetails: [],
  isDogFoodActive: false,
  insights: [],
  filteredInsights: [],
  renderingInsights: [],
  latestDate: "09-06-2025"
};

const performancePulseSlice = createSlice({
  name: "performancePulse",
  initialState,
  reducers: {

    setLatestDate: (state, action) => {
      state.latestDate = action.payload;
    },

    setToggleFood: (state, action) => {
      state.isDogFoodActive = !action.payload;
    },

    setActiveSegment: (state, action) => {
      state.activeSegment = action.payload;
    },

    setMiniCardDetails: (state, action) => {
      const metricDetails = Array.isArray(action.payload)
        ? action.payload
        : [];

      const activeSegment = state.activeSegment;
      const parentId = state.topicIds[activeSegment];
      console.log("Parent ID for Active Segment:", parentId);

      if (!parentId) {
        state.miniCardDetails = [];
        return;
      }

      const filteredMetrics = metricDetails
        .filter(
          (metric) => metric.parent_id === parentId && (metric.display_order ?? 0) !== 0
        )
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

      console.log("Filtered Metrics for Mini Cards:", filteredMetrics);

      // ---- NEW CLEANER FUNCTION ADDED HERE ----
      const cleanRatioUnit = (unit = "") => {
        const normalized = unit.replace(/\s+/g, ""); // remove spaces

        if (normalized.startsWith("ratio")) {
          // remove “ratio” and keep what follows (like /5)
          return normalized.replace("ratio", "");
        }
        return unit;
      };
      // -----------------------------------------

      const formatNumberSmart = (num: string | null | undefined) => {
        if (num === null || num === undefined || num === "") return "";

        const n = Number(num);
        const fixed = n.toFixed(2);

        // If .00 → display integer
        if (fixed.endsWith(".00")) {
          return String(parseInt(fixed, 10));
        }

        return fixed; // Always two decimals
      };

      const formattedMiniCards = filteredMetrics.map((metric) => {
        // Get units
        let prefixUnit =
          metric.units?.find((u: { prefix: boolean; }) => u.prefix === true)?.unit || "";
        let suffixUnit =
          metric.units?.find((u: { prefix: boolean; }) => u.prefix === false)?.unit || "";

        // ---- CLEAN BEFORE USING ----
        prefixUnit = cleanRatioUnit(prefixUnit);
        suffixUnit = cleanRatioUnit(suffixUnit);

        const roundedValue = formatNumberSmart(metric.value);
        const value = `${prefixUnit} ${roundedValue} ${suffixUnit}`;

        // Delta units
       let deltaPrefix =
          metric.delta?.unit?.find((u: any) => u.prefix === true)?.unit || "";
        let deltaSuffix =
          metric.delta?.unit?.find((u: any) => u.prefix === false)?.unit || "";

        deltaPrefix = cleanRatioUnit(deltaPrefix);
        deltaSuffix = cleanRatioUnit(deltaSuffix);

        const deltaTimeMarker = metric.delta?.time_marker ?? "";
        // const deltaTimeMarker = "";
        const roundedValue2 = formatNumberSmart(metric.delta?.value ?? "");
        const change = `${deltaPrefix}${roundedValue2}${deltaSuffix} ${deltaTimeMarker}`;

        return {
          label: metric.name,
          value,
          trend: metric.delta?.trend ?? "",
          change,
          timeMarker: metric.time_marker ?? ""
        };
      });

      state.miniCardDetails = formattedMiniCards;
    },


    setTopicDetails: (state, action) => {
      const topics = Array.isArray(action.payload) ? action.payload : [];
      console.log("Setting Topic Details:", topics);

      // 1. Sort topics based on display_order
      const sortedTopics = [...topics].sort((a, b) => {
        const da = a.display_order ?? 9999;
        const db = b.display_order ?? 9999;
        return da - db;
      });

      // 2. Build topicIds mapping in sorted order
      const idsMap: Record<string, any> = {};
      sortedTopics.forEach((topic) => {
        if (topic && topic.name && topic.id !== undefined) {
          idsMap[topic.name] = topic.id;
        }
      });

      // 3. Save sorted items
      state.topicDetails = sortedTopics;
      state.topicIds = idsMap;
    },

    setInsights: (state, action) => {
      console.log("Insights for pp", action.payload)
      state.insights = action.payload;
    },

    setFilteredInsights: (state, action) => {
      state.filteredInsights = action.payload;
    },

    setRenderingInsights: (state, action) => {
      const insights = action.payload
      // console.log("Insights for pp",state.insights)
      const activeSegment = state.activeSegment;
      const parentId = state.topicIds[activeSegment];
      console.log("Parent ID for Active Segment in filter:", parentId);

      if (!parentId) {
        state.filteredInsights = [];
        return;
      }

      console.log("Filtered in rendering", insights)

      const FilteredInsights = insights
        .filter(
          (insight: { parent_id: any; }) => insight.parent_id === parentId
        )

      console.log("Filterd Insights in rendering", FilteredInsights[0]?.observations[0]?.text)
      state.renderingInsights = FilteredInsights[0]?.observations[0]?.text;
    },


    setMetricDetails: (state, action) => {
      state.metricDetails = action.payload;
    },

    setFilteredMetrics: (state, action) => {
      console.log("Setting Filter Details:", action.payload);
      state.filteredMetrics = action.payload;
    },

    setFilterDetails: (state, action) => {
      state.filterDetails = action.payload;
    },

    setSelectedFilter: (state, action) => {
      const { title, value } = action.payload;
      state.selectedFilters[title] = value;
    },

    setResetSlectedFilters: (state) => {
      console.log("this is setReset")
      state.selectedFilters = {};
    },

    setMainKPICardDetails: (state, action) => {
      const metricDetails = Array.isArray(action.payload)
        ? action.payload
        : [];

      const filteredMetrics = metricDetails
        .filter(
          (metric) =>
            metric.insights_display_enabled === true &&
            (metric.display_order ?? 0) !== 0
        )
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
        .sort((a, b) => (a.parent_id ?? 0) - (b.parent_id ?? 0));

      console.log("Filtered Metrics for Main KPI Cards:", filteredMetrics);

      const cleanRatioUnit = (unit = "") => {
        const normalized = unit.replace(/\s+/g, ""); // remove spaces

        if (normalized.startsWith("ratio")) {
          // remove “ratio” and keep what follows (like /5)
          return normalized.replace("ratio", "");
        }
        return unit;
      };

      const formatNumberSmart = (num: string | null | undefined) => {
        if (num === null || num === undefined || num === "") return "";

        const n = Number(num);
        const fixed = n.toFixed(2);

        // If .00 → display integer
        if (fixed.endsWith(".00")) {
          return String(parseInt(fixed, 10));
        }

        return fixed; // Always two decimals
      };

      const formattedMiniCards = filteredMetrics.map((metric) => {
        // Format the value (prefix true first, prefix false after value)
        let prefixUnit =
          metric.units?.find((u: any) => u.prefix === true)?.unit || "";
        let suffixUnit =
          metric.units?.find((u: any) => u.prefix === false)?.unit || "";

        prefixUnit = cleanRatioUnit(prefixUnit);
        suffixUnit = cleanRatioUnit(suffixUnit);

        const roundedValue = formatNumberSmart(metric.value);
        const value = `${prefixUnit} ${roundedValue} ${suffixUnit}`;

        // Format the change (delta)
        let deltaPrefix =
          metric.delta?.unit?.find((u: any) => u.prefix === true)?.unit || "";
        let deltaSuffix =
          metric.delta?.unit?.find((u: any) => u.prefix === false)?.unit || "";
        // console.log("Prefix",deltaPrefix)
        // console.log("Suffix",deltaSuffix)
        deltaPrefix = cleanRatioUnit(deltaPrefix);
        deltaSuffix = cleanRatioUnit(deltaSuffix);
        const timeMarkerDelta = metric.delta?.time_marker ?? ""
        // const timeMarkerDelta = ""
        const roundedValue2 = formatNumberSmart(metric.delta?.value ?? "");
        const change = `${deltaPrefix}${roundedValue2}${deltaSuffix} ${timeMarkerDelta}`;
        const id = metric.parent_id;
        const market = metric.source;
        const displayorder = metric.display_order;

        // console.log("Formatted Mini Card:", {
        //   label: metric.name,
        //   value,
        //   trend: metric.trend,
        //   change,
        // });


        return {
          label: metric.name,
          value,
          trend: metric.delta?.trend ?? "",
          change,
          id,
          market,
          displayorder,
          timeMarker: metric.time_marker ?? ""
        };
      });

      state.mainKPICardDetails = formattedMiniCards;
    },

    setChartDetails: (state, action) => {
      state.chartDetails = action.payload;
    },

    setFilteredChartDetails: (state, action) => {
      state.filteredChartDetails = action.payload;
    },

    setRenderingChartDetails: (state, action) => {
      const chartDetails = Array.isArray(action.payload)
        ? action.payload
        : [];

      const activeSegment = state.activeSegment;
      const parentId = state.topicIds[activeSegment];
      console.log("Parent ID for Active Segment:", parentId);

      if (!parentId) {
        state.renderingChartDetails = [];
        return;
      }

      const filteredCharts = chartDetails
        .filter((chart) => chart.parent_id === parentId)
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

      console.log("Filtered Metrics for ChartDetails:", filteredCharts);
      state.renderingChartDetails = filteredCharts;
    }


  },
});

export const {
  setActiveSegment,
  setMiniCardDetails,
  setTopicDetails,
  setMetricDetails,
  setFilterDetails,
  setFilteredMetrics,
  setSelectedFilter,
  setMainKPICardDetails,
  setResetSlectedFilters,
  setChartDetails,
  setFilteredChartDetails,
  setRenderingChartDetails,
  setToggleFood,
  setInsights,
  setFilteredInsights,
  setRenderingInsights,
  setLatestDate
} = performancePulseSlice.actions;

export default performancePulseSlice.reducer;
